import { Getters } from 'vuex-smart-module';
import AlfaApiLoanApplicationsState from './state';

export default class AlfaApiLoanApplicationsGetters extends Getters<AlfaApiLoanApplicationsState> {}
